if (!customElements.get('slk-product-tabs')) {
  customElements.define('slk-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      const nav = this.querySelector('.slk-tabs-nav');
      const tabs = [...nav.querySelectorAll('button')];
      const panels = [...this.querySelectorAll('.slk-tabs-panel')];

      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });

        if (focus) tabs[index].focus();
      };

      nav.setAttribute('role', 'tablist');

      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].tabIndex = 0;

        tab.addEventListener('click', () => select(index));

        tab.addEventListener('keydown', event => {
          let next;

          if (event.key === 'ArrowRight') {
            next = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft') {
            next = (index + tabs.length - 1) % tabs.length;
          } else if (event.key === 'Home') {
            next = 0;
          } else if (event.key === 'End') {
            next = tabs.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          select(next, true);
        });
      });

      select(0);
      nav.hidden = false;
    }
  });
}